import React, { useEffect } from "react";
import { motion, useInView } from "framer-motion"; // Import Framer Motion
import AboutUs from "@/components/about/[slug].js";
import BecomeInstactor from "@/components/about/BecomeInstactor.js";
import BecomeStudent from "@/components/about/BecomeStudent";
import Testimonials from "@/components/about/Testimonials";
import LearningJourney from "@/components/about/LearningJourney";
import Preloader from "@/components/about/Preloader";
import MetaComponent from "@/components/about/MetaCompnent.js";
import LearningPath from "@/components/about/LearningPath";
import Head from "next/head";

const metadata = {
  title: "NEET Support - Your Trusted Counseling Partner",
  description:
    "Learn about NEET Support, your trusted partner for expert guidance, college predictions, rank analysis, and personalized NEET counseling. Start your journey with us",
  keywords: "neet support",
  canonical: "https://neetsupport.com/About-Us",
  robots: "index, follow",
};

export default function AboutPage() {
  useEffect(() => {
    // Smooth scroll to top on refresh
    const scrollToTop = () => {
      const scrollDuration = 100; // Total scroll duration in milliseconds
      const scrollStep = -window.scrollY / (scrollDuration / 15); // Scroll step
      const scrollInterval = setInterval(() => {
        if (window.scrollY > 0) {
          window.scrollBy(0, scrollStep);
        } else {
          clearInterval(scrollInterval); // Stop the interval when at the top
        }
      }, 10); // 15ms for smooth scroll
    };

    scrollToTop();
  }, []); // Empty dependency array ensures it runs once on mount

  // Animation variants for sliding-up effect
  // const slideUpVariants = {
  //   hidden: { opacity: 0, y: 50 },
  //   visible: {
  //     opacity: 1,
  //     y: 0,
  //     transition: { duration: 1, ease: "easeOut" },
  //   },
  // };

  // const AnimatedSection = ({ children }) => {
  //   const ref = React.useRef(null);
  //   const isInView = useInView(ref, { once: true, amount: 0.2 });

  //   return (
  //     <motion.div
  //       ref={ref}
  //       initial="hidden"
  //       animate={isInView ? "visible" : "hidden"}
  //       variants={slideUpVariants}
  //     >
  //       {children}
  //     </motion.div>
  //   );
  // };

  return (
    <div className="main-content">
      <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta charSet="utf-8" />
        <link rel="canonical" href={metadata.canonical} />
        <meta name="robots" content={metadata.robots} />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "NEET Support",
        "url": "https://neetsupport.com/About-Us",
        "logo": "https://neetsupport.com/favicon/neetsupport-logo.webp",
        "image": "https://neetsupport.com/assets/img/home/NeetPredict/1.png",
        "description": "NEET Support is your trusted partner for expert NEET counselling, rank analysis, college predictions, and personalized admission guidance.",
        "foundingDate": "2023-09-01",
        "founder": {
          "@type": "Person",
          "name": "Nirmal Vaishnav"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+91 95604 65351",
          "contactType": "Customer Support",
          "email": "info@neetsupport.com",
          "areaServed": "India"
        },
                       "address": [
                  {
                    "@type": "PostalAddress",
                    "name": "Head Office",
                    "streetAddress": "Ground Floor, C-127, C Block, Sector 63",
                    "addressLocality": "Noida",
                    "addressRegion": "Uttar Pradesh",
                    "postalCode": "201301",
                    "addressCountry": "IN"
                  },
                ],
        "sameAs": [
          "https://www.facebook.com/NEETSupport.comIND",
          "https://www.instagram.com/neetsupportindia/",
          "https://www.linkedin.com/company/neetsupport/",
          "https://www.youtube.com/@NEETSupportIndia"
        ],
        "knowsAbout": [
          "NEET Counseling",
          "NEET Rank Predictor",
          "Medical College Admissions",
          "NEET Cutoff Analysis",
          "Seat Matrix",
          "NEET Counselling Guidance"
        ]
      }
      `,
          }}
        />
      </Head>

      {/* <MetaComponent meta={metadata} /> */}
      <Preloader />

      <div className="content-wrapper js-content-wrapper overflow-hidden">
        {/* <AnimatedSection> */}
        <AboutUs />
        {/* </AnimatedSection> */}

        {/* <AnimatedSection> */}
        <LearningJourney />
        {/* </AnimatedSection> */}

        {/* <AnimatedSection> */}
        <Testimonials />
        {/* </AnimatedSection> */}

        {/* <AnimatedSection> */}
        <LearningPath />
        {/* </AnimatedSection> */}

        {/* <AnimatedSection> */}
        <BecomeInstactor className="!mx-4 md:!mx-20" />
        {/* </AnimatedSection> */}

        {/* <AnimatedSection> */}
        <BecomeStudent className="!mx-4 md:!mx-20" />
        {/* </AnimatedSection> */}
      </div>
    </div >
  );
}
